export default __webpack_public_path__ + "static/rsz_logo_jobboard-3be87777efec686f723fdfb6af2c2f9b.png";